<template>
    <vue-custom-scrollbar class="scroll-area" :settings="scroll_settings">
      <h2>
        {{ $t("Publication") }}:
      </h2>
      <a id="link" v-bind:href="node_seleccionat_store.link" target="_blank">
        <p id="nom_publicacio">{{ node_seleccionat_store.nom }}</p>
        <br />
      </a>
      <p> {{ $t("Year") }}: {{ node_seleccionat_store.any }} </p>
      <p id="titol">
        {{ $t("Authors") }}:
      </p>
      <div class="right-margin-text-ellipsis">
        <p v-for="(autor) in node_seleccionat_store.ind_authors" v-bind:key="autor" @click="$root.$emit('ToggleAuthorSearch',autor)" style="cursor: pointer;">· {{autor}}</p>
      </div>
      <p id="titol">
        {{ $t("Cluster") }}:
      </p>
      <p class="right-margin-text-ellipsis">{{ node_seleccionat_store.cluster === 'undefined' ? this.$t('Non-clustered') : node_seleccionat_store.cluster }}</p>

      <p id="titol">
        {{ $t("Terms") }}:
      </p>
      <div class="right-margin-text-ellipsis">
        <span v-for="(par, index) in this.paraules" v-bind:key="index" @click="$root.$emit('ToggleWordSearch',par)" style="cursor: pointer;">
          <div id="llista">{{ listItemWithComma(par, index, paraules.length) }}</div>
          {{ " " }}
        </span>
      </div>
      <br />
      <div v-if="node_seleccionat_store.disciplines[0] != null">
        <p id="titol">
          {{ $t("Scopus tags") }}:
        </p>
        <span
          v-for="(disc, index) in node_seleccionat_store.disciplines"
          v-bind:key="disc"
        >
          <div id="llista">{{ listItemWithComma(disc, index, node_seleccionat_store.disciplines.length) }}</div>
        </span>
      </div>
      <h3>
        <button style="margin-right: 5px;"
          v-if="
            !this.$store.getters.clusters_seleccionats.includes(
              this.$store.getters.node_Seleccionat.id_cluster
            )
          "
          @click="show_cluster"
        >
          {{ $t("Show cluster info") }}
        </button>
        <button style="margin-right: 5px;" v-else @click="show_cluster">{{ $t("Hide cluster info") }}</button>
        <button style="margin-top: 5px;" @click="undisplay_info">{{ $t("Close") }}</button>
      </h3>
    </vue-custom-scrollbar>
</template>
<script>
import "vue-custom-scrollbar/dist/vueScrollbar.css";
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  components: {
    vueCustomScrollbar,
  },
  name: "Info",
  props: ["api_url"],
  data() {
    return {
      paraules: [],
      scroll_settings: {
        supressScrollX: true,
        minScrollbarLength: 50,
        maxScrollbarLength: 250,
        scrollXMarginOffset: 1000
      }
    };
  },
  computed: {
    node_seleccionat_store() {
      return this.$store.getters.node_Seleccionat;
    },
  },
  methods: {
    undisplay_info: function() {
      this.$store.dispatch("Amaga_info");
    },
    show_cluster: function() {
      let cluster = this.$store.getters.clusters_seleccionats;
      if (!cluster.includes(this.$store.getters.node_Seleccionat.id_cluster))
        cluster.push(this.$store.getters.node_Seleccionat.id_cluster);
      else {
        for (let i in cluster)
          if (cluster[i] == this.$store.getters.node_Seleccionat.id_cluster)
            cluster.splice(i, 1);
      }
      console.log(this.$store.getters.node_Seleccionat.id_cluster);
      this.$store.dispatch("MarcarClusters", cluster);
      if (this.$store.getters.display_cluster) { this.$root.$emit("ActualitzaInfoCluster"); }
      else { this.$root.$emit('ClusterInfoActualitzat'); }
    },
    listItemWithComma(item, index, length) {
      if (index !== length - 1) {
        return `${item},`;
      } else return item;
    },
    update_word_cloud: function(node) {
      let url =
        this.$store.getters.api_url +
        "get_words?id=" +
        node.id;
      var self = this;
      this.paraules = [];
      return new Promise((resolve) => {
        this.$api
          .get(url)
          .then(function(response) {
            self.paraules = [];
            for (let i = 0; i < 10; i++) self.paraules.push(response.data[i]);
            resolve(self.paraules);
          })
          .catch(function(error) {
            // handle error
            console.log(error);
            resolve();
          });
      });
    },
  },
  mounted() {
    this.update_word_cloud(this.$store.getters.node_Seleccionat);
    this.$root.$on('ActualitzaInfoNode', () => {
      this.update_word_cloud(this.$store.getters.node_Seleccionat);
    });
  },
  beforeDestroy() {
    this.$root.$off('ActualitzaInfoNode');
  }
};
</script>
<style>
h3 {
  line-height: 0.4;
}
.scroll-area {
  padding: 0;
  margin: 0;
  width: 100%;
  height: calc(100vh - 88px);
}
p {
  font-size: 10px;
  font-family: Helvetica, Arial, sans-serif;
  color: #0077c8;
  line-height: 0.9;
  padding: 0em;
  margin-top: 0.2em;
}
#nom_publicacio {
  font-style: italic;
  font-weight: bold;
  font-size: 16px;
  text-decoration: underline;
  line-height: 1.2;
  margin-right: 10px;
}
#llista {
  display: inline-block;
  font-size: 14px;
  font-family: Helvetica, Arial, sans-serif;
  color: #0077c8;
  line-height: 1;
  padding: 0em;
  margin-top: 0.2em;
  margin-bottom: 0.5em;
}

#link {
  text-decoration: none;
  font-size: 14px;
  font-family: Helvetica, Arial, sans-serif;
  color: #0077c8;
}
#titol {
  font-weight: bold;
}
.right-margin-text-ellipsis {
  margin-right: 10px;
  overflow-x: hidden; 
  text-overflow: ellipsis;
}
</style>
